import BaseService from '@/services/BaseService';

class SubmittalService extends BaseService {
    getSubmittalList = (data) => this.post(
        `/get-submittal-list?page=${data.page}&per_page=${data.per_page}`,
        data || {},
    );

    getSubmittal = (id) => this.get(`/view-submittal-pdf/${id}`);
}

export default new SubmittalService();
